import { useMemo } from 'react';
import { useAppSelector } from '@/store';
import { hasAnyAuthority } from './has-any-authority';
export function useSessionPermissions() {
    return useAppSelector((s) => s.auth.session?.permissions ?? []);
}
export function useHasAnyAuthority(requiredAny) {
    const permissions = useSessionPermissions();
    return useMemo(() => hasAnyAuthority(permissions, requiredAny), [permissions, requiredAny]);
}
